<div class="input-group input-group-sm">
    <input class="form-control" [(ngModel)]="value" (input)="startDebounce();"/>
</div>  